// extracted by mini-css-extract-plugin
export default {"dynamicInputs":"DynamicInputs_dynamicInputs__PsJ0i","input":"DynamicInputs_input__3+iEc"};